export default [
    {
        path: '/admin/reports/shop-performances',
        name: 'shop-performance',
        meta: { requiresAuth: true },
        component: () =>
            import('@/pages/report/delivery/shop-performance.vue')
    }
]
